import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;
const axios = createAxiosInstance(URL);

export const fetchCustomersSchema = () => axios.get('/api/v1/customers/customers/schema/');

export const fetchEmployeesSchema = () => axios.get('/api/v1/customers/employees/schema/');

export const fetchCustomersMembersSchema = () =>
    axios.get('/api/v1/customers/customers_members/schema/');

export const fetchCustomers = async (params = { page: 1, page_size: 20 }) => {
    const url = '/api/v1/customers/customers/';
    const { results = [], count, next } = await axios.get(url, { params });
    return { results, count, next };
};

export const fetchCustomer = (id) => axios.get(`/api/v1/customers/customers/${id}/`);

export const createCustomer = (data) => axios.post('/api/v1/customers/customers/', data);

export const updateCustomer = ({ id, data }) =>
    axios.patch(`/api/v1/customers/customers/${id}/`, data);

export const fetchCustomersMember = (id) => axios.get(`/api/v1/customers/customers_members/${id}/`);

export const fetchCustomersMembers = async (params = { page: 1, page_size: 20 }) => {
    const url = '/api/v1/customers/customers_members/';
    const { results = [], count, next } = await axios.get(url, { params });
    return { results, count, next };
};

export const createCustomersMembers = (data) =>
    axios.post('/api/v1/customers/customers_members/create_users/', data);

export const updateCustomersMember = (id, { languages, role }) =>
    axios.patch(`/api/v1/customers/customers_members/${id}/`, { languages, role });

export const deleteCustomersMember = (id) =>
    axios.delete(`/api/v1/customers/customers_members/${id}/`);

export const fetchCustomersMembersLanguages = () =>
    axios.get('/api/v1/customers/customers_members/languages/');

export const fetchCustomersAuthors = (id) =>
    axios.get(`/api/v1/customers/customers/${id}/authors/`);

export const fetchCustomersStatistic = (params) => {
    return axios.get('/api/v1/customers/orders_month_statistic/', { params });
};

export const fetchCustomersInvites = (params) => {
    return axios.get('/api/v1/customers/invites/', { params });
};

export const deleteCustomersInvite = (id) => {
    return axios.delete(`/api/v1/customers/invites/${id}/`);
};

export const acceptToJoinCustomersInvites = (id) => {
    return axios.post(`/api/v1/customers/invites/${id}/accept_to_join/`);
};

export const fetchCustomersInvite = (id, params = {}) => {
    return axios.get(`/api/v1/customers/invites/${id}/`, { params });
};

export const fetchCustomersInviteStatuses = (params = {}) => {
    return axios.get(`/api/v1/customers/invites/states/`, { params });
};

export const fetchCustomersDefaultSpeakersSchema = (params = {}) => {
    return axios.get('/api/v1/customers/default_speakers/schema/', { params });
};

export const fetchCustomersDefaultSpeakers = (params = {}) => {
    return axios.get('/api/v1/customers/default_speakers/', { params });
};

export const createCustomersDefaultSpeaker = (data) => {
    return axios.post('/api/v1/customers/default_speakers/', data);
};

export const updateCustomersDefaultSpeaker = (id, data) => {
    return axios.patch(`/api/v1/customers/default_speakers/${id}/`, data);
};

export const deleteCustomersDefaultSpeaker = (id) => {
    return axios.delete(`/api/v1/customers/default_speakers/${id}/`);
};

export const getCustomersEmployeesMembership = (params = {}) => {
    return axios.get('/api/v1/customers/employees/membership/', { params });
};

export const getСustomersMembersMembership = (params = {}) => {
    return axios.get('/api/v1/customers/customers_members/membership/', { params });
};

//
export const confirmCustomersInvite = (url, body = {}, params = {}) => {
    if (!url) throw 'Confirm invite: no url';

    return axios.post(url, body, { params });
};
//
